export default __webpack_public_path__ + "static/yt_logo_rgb_light-632114b015090cd234ffc95fb48e4245.png";